import { useApi } from '~/api'
import { defineService } from '~/api/models/helpers'
import type { PaginationParams } from '~/types/pagination'
import type { AuthArgs } from '~/api/models/index'

const queries = {
  getAllByRuleId: {
    queryFn: (params: { ruleId: number; pagination: PaginationParams }) =>
      useApi().alerts.getAlertsByRuleId(params.ruleId, params.pagination),
    queryKey: (params: { ruleId: number; pagination: PaginationParams }) => [
      'alertsByRule',
      String(params.ruleId),
      String(params.pagination)
    ],
    options: {
      staleTime: () => 1000 * 60 // 1 minute
    }
  }
} as const
const mutations = {
  dismiss: {
    request: (id: number) => useApi().alerts.dismissAlertById(id),
    cacheKey: () => ['alertsByRule']
  }
} as const

export type AlertService = ReturnType<typeof defineService<typeof queries, typeof mutations>>

export const registerService = (authArgs: AuthArgs): AlertService =>
  defineService(authArgs, {
    queries,
    mutations
  })
